import React from 'react';
import { Controller, Control } from 'react-hook-form';
import FormControlLabel, {
  FormControlLabelProps,
} from '@mui/material/FormControlLabel';
import { Checkbox as MuiCheckbox, styled } from '@mui/material';

interface CheckboxProps {
  label: string;
  name: string;
  className?: string;
  control: Control<any>;
  required?: boolean;
  defaultValue?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  dataFsElement?: string;
}

const StyledCheckbox = styled(MuiCheckbox, {
  shouldForwardProp: (prop) => prop !== 'readOnly',
})(({ theme, readOnly }) => ({
  ...(readOnly && {
    '&.MuiCheckbox-root': {
      color: theme.palette.lightActionDisabled26p.main,
    },
    '&.Mui-checked': {
      color: theme.palette.lightActionDisabled54p.main,
    },
  }),
}));

interface ExtendedFormControlLabelProps extends FormControlLabelProps {
  readOnly?: boolean;
  checked?: boolean;
}

const StyledFormControlLabel = styled(
  FormControlLabel,
)<ExtendedFormControlLabelProps>(({ theme, readOnly, checked }) => ({
  ...(readOnly && {
    pointerEvents: 'none',
    cursor: 'default',
    ...(!checked && {
      '& .MuiFormControlLabel-label': {
        color: theme.palette.lightActionDisabled45p.main,
      },
    }),
  }),
}));

const Checkbox = React.forwardRef<HTMLButtonElement, CheckboxProps>(
  (
    {
      label,
      name,
      className,
      control,
      required = false,
      defaultValue = false,
      disabled = false,
      readOnly = false,
      dataFsElement,
    },
    ref,
  ) => {
    return (
      <Controller
        name={name as any}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <StyledFormControlLabel
            label={label}
            className={className}
            readOnly={readOnly}
            checked={field.value}
            control={
              <StyledCheckbox
                ref={ref}
                color="primary"
                required={required}
                disabled={disabled}
                onChange={(e) => field.onChange(e.target.checked)}
                checked={field.value}
                sx={{ fontSize: 24 }}
                readOnly={readOnly}
                data-fs-element={dataFsElement}
              />
            }
          />
        )}
      />
    );
  },
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
